<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">围栏名称：</div>
        <el-input
          placeholder="请输入围栏名称"
          size="medium"
          v-model="queryInfo.fenceName"
          @change="getFence()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位人员设备卡片区域 -->
      <div class="leftBox">
        <!-- 单位人员设备树 -->

        <el-tree
          class="treeBox"
          :data="ArchInfo"
          :props="defaultTreesProps"
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          node-key="name"
          ref="navTree"
          @check-change="getCheckedDevicesNodes"
        >
          <!-- :render-content="renderContent"  -->
          <span slot-scope="{ node, data }">
            <div class="bigTree">
              <div class="leftTree">
                <div>
                  <!-- 单位图标 -->
                  <img
                    v-show="data.type == 1"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/dw.svg"
                  />
                  <!-- 人员图标 -->
                  <img
                    v-show="data.type == 2"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/ry.svg"
                  />
                  <!-- 执法仪不在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == false"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj.svg')
                        : require('../../../assets/img/tree/zngb.svg')
                    "
                  />
                  <!-- 执法仪在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == true"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy_online.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq_online.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm_online.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj_online.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj_online.svg')
                        : require('../../../assets/img/tree/zngb_online.svg')
                    "
                  />
                </div>

                <!-- 设备名称 -->
                <el-tooltip
                  v-show="data.type == 3"
                  class="item"
                  effect="dark"
                  :content="node.label"
                  placement="top"
                >
                  <div ref="nodeLabel">
                    <div v-if="node.label.length > 8">
                      {{
                        node.label.replace(
                          /(\d{3})\d*([0-9a-zA-Z]{3})/,
                          "$1***$2"
                        )
                      }}
                    </div>
                    <div v-else>
                      {{ node.label }}
                    </div>
                  </div>
                </el-tooltip>

                <!--  -->
                <!-- 单位和人员名称 -->
                <div ref="nodeLabel" v-show="data.type == 1 || data.type == 2">
                  {{ node.label }}
                </div>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
      <!-- 右边单位人员设备卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加围栏按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="addFenceOpenDialogVisible()"
          >
            创建电子围栏
          </el-button>
          <!-- 增加围栏按钮 -->
          <el-button
            icon="el-icon-share"
            type="primary"
            size="small"
            class="add-btn"
            @click="sendFenceToDevices"
            v-if="sendFenceBtn"
          >
            下发围栏
          </el-button>
          <!-- 围栏信息表格区域 -->
          <el-table
            :data="FenceList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
            :header-cell-class-name="headerCellStyle"
            @select="selectChange"
            @selection-change="handleSelectionChange"
            ref="FenceListTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="fenceName" label="围栏名称">
            </el-table-column>
            <el-table-column prop="fenceCreatetime" label="创建时间">
            </el-table-column>
            <el-table-column prop="fenceChildrenShow" label="允许下级项目查看">
              <template v-slot="fenceSlot">
                <span>{{
                  fenceSlot.row.fenceChildrenShow == false ? "否" : "是"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="绑定设备">
              <template v-slot="slotFenceId">
                <el-button
                  type="primary"
                  size="small"
                  @click="getFenceIdDevice(slotFenceId.row.fenceId)"
                  >查看下发设备</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="openUpdateFence(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteFenceByplId(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加电子围栏信息对话框 -->
    <el-dialog
      title="新增电子围栏"
      :visible.sync="AddFenceDialogVisible"
      width="70%"
      :close-on-click-modal="false"
      @close="clearAddFenceDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form ref="addFenceFormRef" :model="FenceInfo" label-width="80px">
        <div style="display: flex">
          <el-form-item prop="fenceName" label="围栏名称">
            <el-input
              placeholder="请输入电子围栏名称"
              v-model="FenceInfo.fenceName"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="允许下级项目查看" label-width="150px">
            <el-radio-group v-model="FenceInfo.fenceChildrenShow">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="map">
          <!-- 地图 -->
          <div id="addMap-container" class="mapBox"></div>

          <!-- 左侧操作区 -->
          <div class="s-control-l">
            <!-- <v-region @values="regionChange" class="form-control"></v-region> -->
            <region-selects @change="regionChange" class="form-control" />
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="drawRegion"
              >绘制区域</el-button
            >
          </div>

          <!-- 右侧操作区 -->
          <div class="s-control-r">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="" style="margin-right: 30px">
                <el-input
                  v-model.lazy="keyword"
                  placeholder="请输入地名"
                  prefix-icon="el-icon-search"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item label="">
                <el-radio-group v-model="radioSelect" size="mini">
                  <el-radio-button label="none"
                    ><span class="s-icon s-icon-select"></span
                  ></el-radio-button>
                  <el-radio-button label="circle"
                    ><span class="s-icon s-icon-circle"></span>
                  </el-radio-button>
                  <el-radio-button label="polygon"
                    ><span class="s-icon s-icon-polygon"></span>
                  </el-radio-button>
                  <el-radio-button label="rectangle"
                    ><span class="s-icon s-icon-rectangle"></span>
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- 地区检索显示区 -->
              <div id="search-result"></div>
            </el-form>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddFenceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddFence()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改车牌信息对话框 -->
    <el-dialog
      title="修改电子围栏"
      :visible.sync="UpdateFenceDialog"
      width="70%"
      :close-on-click-modal="false"
      @close="clearUpdateDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updateFenceFormRef"
        :rules="AddPlNumberRules"
        :model="UpdateInfo"
        label-width="80px"
      >
        <div style="display: flex">
          <el-form-item prop="fenceName" label="围栏名称">
            <el-input
              placeholder="请输入电子围栏名称"
              v-model="UpdateInfo.fenceName"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="允许下级项目查看" label-width="150px">
            <el-radio-group v-model="UpdateInfo.fenceChildrenShow">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="map">
          <!-- 地图 -->
          <div id="map-container" class="mapBox"></div>

          <!-- 左侧操作区 -->
          <div class="s-control-l">
            <!-- <v-region @values="regionChange" class="form-control"></v-region> -->
            <region-selects @change="regionChange" class="form-control" />
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="drawRegion"
              >绘制区域</el-button
            >
          </div>

          <!-- 右侧操作区 -->
          <div class="s-control-r">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="" style="margin-right: 30px">
                <el-input
                  v-model.lazy="keyword"
                  placeholder="请输入地名"
                  prefix-icon="el-icon-search"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item label="">
                <el-radio-group v-model="radioSelect" size="mini">
                  <el-radio-button label="none"
                    ><span class="s-icon s-icon-select"></span
                  ></el-radio-button>
                  <el-radio-button label="circle"
                    ><span class="s-icon s-icon-circle"></span>
                  </el-radio-button>
                  <el-radio-button label="polygon"
                    ><span class="s-icon s-icon-polygon"></span>
                  </el-radio-button>
                  <el-radio-button label="rectangle"
                    ><span class="s-icon s-icon-rectangle"></span>
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- 地区检索显示区 -->
              <div id="search-result"></div>
            </el-form>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateFenceDialog = false">取 消</el-button>
        <el-button type="primary" @click="Update()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看下发电子围栏信息对话框 -->
    <el-dialog
      title="电子围栏已下发设备"
      :visible.sync="sendDevicesDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearsendDevicesDialogVisible()"
    >
      <el-table
        :data="sendDevicesList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
        :default-sort="{ prop: 'devCreatetime', order: 'descending' }"
      >
        <el-table-column prop="devEmpName" label="使用人员"> </el-table-column>
        <el-table-column prop="devNo" label="设备编号"> </el-table-column>
        <el-table-column prop="devCreatetime" sortable label="下发时间">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="UnissueSlot">
            <el-button
              type="warning"
              size="small"
              @click="Unissue(UnissueSlot.row.devId)"
              >解除下发</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>


<script>
// 基于 Vue2 的中国行政区划选择器
import { RegionSelects } from "v-region";
// 引入百度地图样式
import custom_map_config from "../../../assets/css/custom_map_config4.json";
export default {
  data() {
    return {
      // 围栏列表信息
      FenceList: [],
      // 围栏列表查询信息
      queryInfo: {
        // 围栏名称
        fenceName: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //  单位总数量
      total: 0,
      // 单位人员设备树信息
      ArchInfo: [],
      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name",
      },
      // 控制增加电子围栏对话框的显示和隐藏
      AddFenceDialogVisible: false,
      // 控制发送电子围栏按钮显示与隐藏
      sendFenceBtn: false,
      // 下发电子围栏参数
      sendFenceToDevicesInfo: {
        devIds: [], //设备id
        fenceId: "", //电子围栏ID
      },
      // 围栏实体
      FenceInfo: {
        // 坐标点
        fenceData: "",
        // 电子围栏名称
        fenceName: "",
        // 是否允许下级单位查看
        fenceChildrenShow: "",
      },
      // 查看下发设备对话框
      sendDevicesDialog: false,
      // 车牌下发设备
      sendDevicesList: [],
      //解除电子围栏下发设备的电子围栏ID
      unissueFenceId: "",
      // 控制修改对话框的显示和隐藏
      UpdateFenceDialog: false,
      // 修改电子围栏实体
      UpdateInfo: {
        // 坐标点
        fenceData: "",
        // 电子围栏名称
        fenceName: "",
        // 围栏ID
        fenceId: "",
        // 是否允许下级单位查看
        fenceChildrenShow: "",
      },
      //增加车牌规则校验
      AddPlNumberRules: {},
      // ============电子围栏内容==============
      name: "draw",
      center: { lng: 116.93761, lat: 40.059866 }, // 中心点坐标
      zoom: 4, // 缩放级别
      location: "深圳市",
      keyword: "",
      radioSelect: "none",
      styleOptions: {
        strokeColor: "#fa0c0c", // 边线颜色
        fillColor: "#5E87DB", // 填充颜色。当参数为空时，圆形没有填充颜色
        strokeWeight: 2, // 边线宽度，以像素为单位
        strokeOpacity: 1, // 边线透明度，取值范围0-1
        fillOpacity: 0.2, // 填充透明度，取值范围0-1
      },
      labelOptions: {
        borderRadius: "2px",
        background: "#FFFBCC",
        border: "1px solid #E1E1E1",
        color: "#703A04",
        fontSize: "12px",
        letterSpacing: "0",
        padding: "5px",
      },
      map: null, // 百度地图
      drawingManager: null, // 鼠标绘制工具
      localSearch: null, // 地区检索
      region: {}, // 行政区域
      // ============电子围栏内容==============
    };
  },
  created() {
    // 获取围栏列表信息
    this.getFence();
    // 获取单位人员设备树
    this.getDepPersonDevTree();
  },
  components: {
    RegionSelects,
  },
  watch: {
    // 绘制类型变更
    radioSelect(nval, oval) {
      if (nval != "none") {
        this.clearOverlays();
        this.drawingManager.close();
        this.draw(nval);
      } else {
        this.drawingManager.close();
      }
    },
    // 地区检索关键字变更
    keyword(nval, oval) {
      this.localSearch.clearResults();
      this.localSearch.search(nval);
    },
  },

  mounted() {},
  methods: {
    // 打开创建电子围栏对话框
    addFenceOpenDialogVisible() {
      this.AddFenceDialogVisible = true;
      setTimeout(() => {
        // 创建Map实例
        this.map = new BMapGL.Map("addMap-container", {
          enableMapClick: false,
          minZoom: 4,
          maxZoom: 19,
        });
        // 设置中心点坐标和地图级别
        setTimeout(() => {
          this.map.centerAndZoom(
            new BMapGL.Point(this.center.lng, this.center.lat),
            this.zoom
          );
        }, 1000);
        // 开启鼠标滚轮缩放
        this.map.enableScrollWheelZoom(true);

        // 创建鼠标绘制工具
        this.drawingManager = new BMapGLLib.DrawingManager(this.map, {
          // isOpen: true, //是否开启绘制模式
          enableCalculate: true, // 绘制是否进行测距(画线时候)、测面(画圆、多边形、矩形)
          drawingToolOptions: {
            enableTips: true,
            customContainer: "selectbox_Drawing",
            hasCustomStyle: true,
            offset: new BMapGL.Size(5, 5), // 偏离值
            scale: 0.8, // 工具栏缩放比例
            drawingModes: [
              BMAP_DRAWING_RECTANGLE,
              BMAP_DRAWING_POLYGON,
              BMAP_DRAWING_CIRCLE,
            ],
          },
          enableSorption: true, // 是否开启边界吸附功能
          sorptionDistance: 20, // 边界吸附距离
          enableGpc: true, // 是否开启延边裁剪功能
          enbaleLimit: true, // 是否开启超限提示
          // limitOptions: {
          //     area: 50000000 // 面积超限值
          // },
          circleOptions: this.styleOptions, // 圆的样式
          polylineOptions: this.styleOptions, // 线的样式
          polygonOptions: this.styleOptions, // 多边形的样式
          rectangleOptions: this.styleOptions, // 矩形的样式
          labelOptions: this.labelOptions, // label的样式
        });

        //地图个性化样式
        this.map.setMapStyleV2({
          // styleId: "a0c43e8c7279db0a4a032712d0e4c32c", //官网地图api个性化获取
          // styleJson:[{ }] //也可以json方式个性化
          styleJson: custom_map_config,
        });

        // 实例化地区检索
        this.localSearch = new BMapGL.LocalSearch(this.map, {
          renderOptions: { map: this.map, panel: "search-result" },
        });

        // 加载围栏数据
        // this.loadHurdle();
      }, 1000);
    },
    mapFence(callback) {
      setTimeout(() => {
        // 创建Map实例
        this.map = new BMapGL.Map("map-container", {
          enableMapClick: false,
          minZoom: 4,
          maxZoom: 19,
        });
        // 设置中心点坐标和地图级别
        this.map.centerAndZoom(
          new BMapGL.Point(this.center.lng, this.center.lat),
          this.zoom
        );

        // 开启鼠标滚轮缩放
        this.map.enableScrollWheelZoom(true);

        // 创建鼠标绘制工具
        this.drawingManager = new BMapGLLib.DrawingManager(this.map, {
          // isOpen: true, //是否开启绘制模式
          enableCalculate: true, // 绘制是否进行测距(画线时候)、测面(画圆、多边形、矩形)
          drawingToolOptions: {
            enableTips: true,
            customContainer: "selectbox_Drawing",
            hasCustomStyle: true,
            offset: new BMapGL.Size(5, 5), // 偏离值
            scale: 0.8, // 工具栏缩放比例
            drawingModes: [
              BMAP_DRAWING_RECTANGLE,
              BMAP_DRAWING_POLYGON,
              BMAP_DRAWING_CIRCLE,
            ],
          },
          enableSorption: true, // 是否开启边界吸附功能
          sorptionDistance: 20, // 边界吸附距离
          enableGpc: true, // 是否开启延边裁剪功能
          enbaleLimit: true, // 是否开启超限提示
          // limitOptions: {
          //     area: 50000000 // 面积超限值
          // },
          circleOptions: this.styleOptions, // 圆的样式
          polylineOptions: this.styleOptions, // 线的样式
          polygonOptions: this.styleOptions, // 多边形的样式
          rectangleOptions: this.styleOptions, // 矩形的样式
          labelOptions: this.labelOptions, // label的样式
        });

        //地图个性化样式
        this.map.setMapStyleV2({
          // styleId: "a0c43e8c7279db0a4a032712d0e4c32c", //官网地图api个性化获取
          // styleJson:[{ }] //也可以json方式个性化
          styleJson: custom_map_config,
        });

        // 实例化地区检索
        this.localSearch = new BMapGL.LocalSearch(this.map, {
          renderOptions: { map: this.map, panel: "search-result" },
        });

        // 在百度地图加载完成后调用回调函数
        callback();
        // 加载围栏数据
        // this.loadHurdle();
      }, 1000);
    },
    // 查询围栏列表信息
    async getFence() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/position/fence/search`,
        { params: this.queryInfo }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.FenceList = res.data.rows;
      // 电子围栏总数量
      this.total = res.data.total;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getFence();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getFence();
    },

    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;
    },

    //获取tree选中的设备devIds
    getCheckedDevicesNodes() {
      var devices = this.$refs.navTree.getCheckedNodes();
      var devIds = [];
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.type == 3) {
          devIds.push(element.id);
        }
      }
      this.sendFenceToDevicesInfo.devIds = devIds;
    },
    // 获取table选中的电子围栏信息
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.sendFenceBtn = true;
        this.sendFenceToDevicesInfo.fenceId = val[0].fenceId;
        // console.log(this.sendFenceToDevicesInfo.fenceId);
      } else {
        this.sendFenceBtn = false;
      }
      // var plIds = [];
      // for (let i = 0; i < val.length; i++) {
      //   plIds.push(val[i].plId);
      // }
    },
    // 电子围栏下发
    async sendFenceToDevices() {
      if (this.sendFenceToDevicesInfo.devIds.length == 0) {
        return this.$message.warning("请选择要下发的设备!");
      }
      const { data: res } = await this.$axios.post(
        `${this.$api}/position/fence/send`,
        this.sendFenceToDevicesInfo
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 清空树的选中
      this.$refs.navTree.setCheckedNodes([]);
      // 清空表格选中
      this.$refs.FenceListTable.clearSelection();
      this.$message.success("电子围栏下发成功");
    },

    // 根据电子围栏查看对应下发的设备
    async getFenceIdDevice(fenceId) {
      this.unissueFenceId = fenceId;
      const { data: res } = await this.$axios.get(
        `${this.$api}/position/fence/getFenceDevice`,
        {
          params: { fenceId: fenceId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesDialog = true;
      if (res.data.rows !== null && res.data.rows !== "") {
        this.sendDevicesList = res.data.rows;
      }
    },

    // 将table表格设置成单选
    headerCellStyle({ column, columnIndex }) {
      if (columnIndex === 0) {
        return "hiddenCheck";
      }
    },

    // 改为单选，即通过Array.shift()方法删除第一条数据并返回新数组，这样就可以把select 事件中的以获取的数组给删掉，同时通过toggleRowSelection方法将删掉的这一行选择状态设置为未选择。
    selectChange(selection) {
      if (selection.length > 1) {
        const del_row = selection.shift();
        this.$refs.FenceListTable.toggleRowSelection(del_row, false);
      }
    },

    // 解除设备下发电子围栏
    async Unissue(devId) {
      const confirmVal = await this.$confirm(
        "此操作将会解除此设备的电子围栏下发, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/position/fence/unissue`,
        {
          params: { devId: devId, fenceId: this.unissueFenceId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesList = [];
      this.getFenceIdDevice(this.unissueFenceId);
      this.$message.success("该设备已解除电子围栏");
    },
    // 关闭电子围栏查看对应下发的设备对话框
    clearsendDevicesDialogVisible() {
      this.sendDevicesList = [];
    },
    // 增加电子围栏
    AddFence() {
      var overlays = this.map.getOverlays();
      var pointsStrArr = [];
      overlays.forEach((item) => {
        if (item.getPath) {
          var pointsStr = this.pointsToStr(item.getPath());
          pointsStr && pointsStrArr.push(pointsStr);
        }
      });
      if (pointsStrArr.length == 0) {
        this.$message({
          message: "操作失败，您没用绘制任何有效区域",
          type: "error",
        });
        return;
      }

      if (this.FenceInfo.fenceName == "") {
        this.$message({
          message: "操作失败,您没有输入电子围栏名称",
          type: "error",
        });
        return;
      }

      // 后台保存需要的路径坐标数据
      this.FenceInfo.fenceData = pointsStrArr.join(";");

      this.$refs.addFenceFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/position/fence/add`,
          this.FenceInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("新增电子围栏成功");
        this.AddFenceDialogVisible = false;
        this.getFence();
      });
    },
    //关闭增加电子围栏信息
    clearAddFenceDialogVisible() {
      this.$refs.addFenceFormRef.resetFields();
      this.FenceInfo.fenceName = "";
      this.FenceInfo.fenceChildrenShow = "";
      this.keyword = "";
      this.region = {};
    },
    //打开修改电子围栏信息对话框
    openUpdateFence(vule) {
      this.UpdateFenceDialog = true;
      // 使用Promise包装mapFence函数
      const mapFencePromise = new Promise((resolve, reject) => {
        this.mapFence(resolve);
      });

      // 使用async/await等待mapFencePromise完成
      (async () => {
        await mapFencePromise;
        // 电子围栏名称
        this.UpdateInfo.fenceName = vule.fenceName;
        // 坐标点
        this.UpdateInfo.fenceData = vule.fenceData;
        // 围栏ID
        this.UpdateInfo.fenceId = vule.fenceId;
        // 是否允许下级单位查看
        this.UpdateInfo.fenceChildrenShow = vule.fenceChildrenShow;

        var pointsArr = [];
        pointsArr = new Array(vule.fenceData);
        var pathArr = [];
        pointsArr.forEach((item) => {
          var ply = new BMapGL.Polygon(item, this.styleOptions); //建立多边形覆盖物
          this.map.addOverlay(ply); //添加覆盖物
          pathArr = pathArr.concat(ply.getPath());
        });
        this.map.setViewport(pathArr); //调整视野
      })();
    },

    // 修改电子围栏信息
    async Update() {
      var overlays = this.map.getOverlays();
      var pointsStrArr = [];
      overlays.forEach((item) => {
        if (item.getPath) {
          var pointsStr = this.pointsToStr(item.getPath());
          pointsStr && pointsStrArr.push(pointsStr);
        }
      });
      if (pointsStrArr.length == 0) {
        this.$message({
          message: "操作失败，您没用绘制任何有效区域",
          type: "error",
        });
        return;
      }

      if (this.UpdateInfo.fenceName == "") {
        this.$message({
          message: "操作失败,您没有输入电子围栏名称",
          type: "error",
        });
        return;
      }

      // 后台保存需要的路径坐标数据
      this.UpdateInfo.fenceData = pointsStrArr.join(";");
      this.$refs.updateFenceFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/position/fence/modify/${this.UpdateInfo.fenceId}`,
          {
            // 围栏名称
            fenceName: this.UpdateInfo.fenceName,
            // 经纬度
            fenceData: this.UpdateInfo.fenceData,
            // 是否允许下级单位查看
            fenceChildrenShow: this.UpdateInfo.fenceChildrenShow,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("修改电子围栏信息成功");
        this.getFence();
        this.UpdateFenceDialog = false;
      });
    },

    //关闭修改电子围栏信息对话框
    clearUpdateDialogVisible() {
      this.$refs.updateFenceFormRef.resetFields();
      this.keyword = "";
      this.region = {};
    },
    // 删除电子围栏
    async deleteFenceByplId(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该电子围栏, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/position/fence/delete/` + value.fenceId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("电子围栏删除成功");
      this.getFence();
    },

    // 地图区域
    // 清除地图覆盖物
    clearOverlays() {
      this.map.clearOverlays();
    },

    // 绘制圆、矩形、多边形
    draw(type) {
      var arr = document.getElementsByClassName("bmap-btn");
      for (var i = 0; i < arr.length; i++) {
        arr[i].style.backgroundPositionY = "0";
      }
      switch (type) {
        case "marker": {
          var drawingType = BMAP_DRAWING_MARKER;
          break;
        }
        case "polyline": {
          var drawingType = BMAP_DRAWING_POLYLINE;
          break;
        }
        case "rectangle": {
          var drawingType = BMAP_DRAWING_RECTANGLE;
          break;
        }
        case "polygon": {
          var drawingType = BMAP_DRAWING_POLYGON;
          break;
        }
        case "circle": {
          var drawingType = BMAP_DRAWING_CIRCLE;
          break;
        }
      }
      // 进行绘制
      if (
        this.drawingManager._isOpen &&
        this.drawingManager.getDrawingMode() === drawingType
      ) {
        this.drawingManager.close();
      } else {
        this.drawingManager.setDrawingMode(drawingType);
        this.drawingManager.open();
      }
    },

    // 绘制行政区域
    drawRegion() {
      if (!this.region.value) {
        this.$message({
          message: "操作失败，请选择区域",
          type: "error",
        });
        return;
      }
      this.radioSelect = "none";
      var bdary = new BMapGL.Boundary();
      bdary.get(this.region.value, (rs) => {
        // console.log("rs:" + rs.boundaries);
        //获取行政区域
        this.map.clearOverlays(); //清除地图覆盖物
        var count = rs.boundaries.length; //行政区域的点有多少个
        if (count === 0) {
          alert("未能获取当前输入行政区域");
          return;
        }
        var pointArray = [];
        for (var i = 0; i < count; i++) {
          // console.log(rs.boundaries[i]);
          var ply = new BMapGL.Polygon(rs.boundaries[i], this.styleOptions); //建立多边形覆盖物
          var str = JSON.stringify(ply.ia); //将BMap获取的行政区边界经纬度转为字符串
          this.map.addOverlay(ply); //添加覆盖物
          pointArray = pointArray.concat(ply.getPath());
        }
        this.map.setViewport(pointArray); //调整视野
      });
    },

    // 返回
    goBack() {
      this.map.clearOverlays();
    },

    // 切换地区
    regionChange(data) {
      // console.log(data.area);
      // console.log(data.town);
      this.region = data.area || data.city || data.province || {};
      // console.log("region:" + this.region.value);
    },

    // 加载围栏数据
    // async loadHurdle() {
    //   const {
    //     data: { points },
    //   } = await this.$axios.get("/api/getCurrent");
    //   var pointsArr = JSON.parse(points);
    //   var pathArr = [];
    //   pointsArr.forEach((item) => {
    //     var ply = new BMap.Polygon(item, this.styleOptions); //建立多边形覆盖物
    //     this.map.addOverlay(ply); //添加覆盖物
    //     pathArr = pathArr.concat(ply.getPath());
    //   });
    //   this.map.setViewport(pathArr); //调整视野
    // },
    // 保存围栏数据
    saveHurdle() {
      var overlays = this.map.getOverlays();
      var pointsStrArr = [];
      overlays.forEach((item) => {
        if (item.getPath) {
          var pointsStr = this.pointsToStr(item.getPath());
          pointsStr && pointsStrArr.push(pointsStr);
        }
      });
      if (pointsStrArr.length == 0) {
        this.$message({
          message: "操作失败，您没用绘制任何有效区域",
          type: "error",
        });
        return;
      }
      // 后台保存需要的路径坐标数据
      const data = JSON.stringify(pointsStrArr);
      alert(data);
    },
    // 坐标点数组转字符串
    pointsToStr(points) {
      if (!points) return "";
      var str = "";
      points.forEach((item) => {
        str += item.lng + "," + item.lat + ";";
      });
      return str.slice(0, -1);
    },
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 260px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  display: flex;
}

.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  // width: 1%;
  vertical-align: center;
}

// 地图区域

.map {
  height: 500px;
  width: 100%;
}
.mapBox {
  width: 100%;
  height: 500px;
}

.el-page-header,
.el-footer {
  line-height: 60px;
}

.rg-select__el {
  background: #ffffff !important;
}

#map-container {
  width: 100%;
  height: 100%;
}
#addMap-container {
  width: 100%;
  height: 100%;
}

.demo-form-inline .el-input__inner {
  margin: 0px !important;
}

#search-result {
  width: 400px;
}

.s-control-l {
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 30px;
  top: 150px;
  z-index: 999;
}

.s-control-r {
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  top: 150px;
  z-index: 999;
}

.s-search {
  width: 400px;
}

.s-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.s-icon.s-icon-select {
  background-image: url(data:image/png;base64,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);
}
.el-radio-button.is-active .s-icon.s-icon-select {
  background-image: url(data:image/png;base64,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);
}

.s-icon.s-icon-circle {
  background-image: url(data:image/png;base64,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);
}
.el-radio-button.is-active .s-icon.s-icon-circle {
  background-image: url(data:image/png;base64,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);
}

.s-icon.s-icon-polygon {
  background-image: url(data:image/png;base64,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);
}
.el-radio-button.is-active .s-icon.s-icon-polygon {
  background-image: url(data:image/png;base64,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);
}
.s-icon.s-icon-rectangle {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAALVBMVEUAAACdnZ2Xl5eYmJiZmZmZmZmZmZmZmZmYmJiZmZmZmZk4jP98lbeZmZn///8t8ZxiAAAAC3RSTlMAGjFNX32CoLPO5hUiNAEAAAABYktHRA5vvTBPAAAArklEQVRYw2NgGAWkg1mrIKAAtxJ2qJKVUP7auxDQgFsLB1TJLTprURQUFPTFr+UKUIkQkhYBIGmLX8tlIMmIoeX0bpxgz1DTQob3SdLibGxsnItfyzWgEhO6JxiStVR0dJw509HREYBbC2sHRE07Qmj3bsI5EU3NqJZRLaNaRrWMahnVMqplVMuollEtA6WFjEbvIO4kktEZoU8vaYT3K8novA/SNEbGoMooIAUAABF2jY+JYPkUAAAAAElFTkSuQmCC);
}
.el-radio-button.is-active .s-icon.s-icon-rectangle {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMAGjFNX32CoLPO5hUiNAEAAAABYktHRAsf18TAAAAAqklEQVRYw2NgGAWkg1mrIKAAtxJ2qJKVUP7q3RDQgFsLB1TJLjprURQUFPTGr2ULUIkQkhYBIGmNX8tmIMmIoQUvGGJayPA+SVqcjY2Ns/Fr2QZUYkL3BEOyloqOjt27Ozo6AnBrYe2AqGlHCO3eTTgnoqkZ1TKqZVTLqJZRLaNaRrWMahnVMqploLSQ0egdxJ1EMjoj9OkljfB+JRmd90GaxsgYVBkFpAAAyZJmP55ExscAAAAASUVORK5CYII=);
}

// 地区选择
/deep/div.rg-select div.rg-select__el {
  color: #3f88f5fd;
}

// 重新设置其样式将该”全选框“隐藏掉。
/deep/.hiddenCheck {
  visibility: hidden;
}
/deep/.el-table__header-wrapper {
  background: #0395d9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/CombinedAction/electronicFence.vue